import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Email — enveloppe duotone (simple, sans check : voir AckIcon) */
export const MailIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Rabat menthe */}
      <path
        d="M3.5 6.5l8.5 6 8.5-6"
        fill="var(--equiply-icon-bg)"
      />
      {/* Enveloppe */}
      <rect x="3" y="5.5" width="18" height="13" rx="1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Rabat */}
      <path
        d="M3.5 6.5l8.5 6 8.5-6"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
    </svg>
  ),
);
MailIcon.displayName = "MailIcon";
